import * as React from 'react';
import { withTranslation } from '@i18n';
import {
  StyledCover,
  StyledTopHeader,
  StyledTitle,
  StyledSubText,
  StyledKnowMoreButton,
  StyledCenterAlignWrapper,
  StyledSeprator,
  StyledTableWrapper,
  StyledSeeMoreButton
} from './styles';
import { StyledGridUnit, StyledGridWrapper } from '../../../../Profile/ProfilePackages/styles';

const CostComparision = ({ t, relationshipData }) => {
  const [seeMore, setSeeMore] = React.useState(false);

  return (
    <StyledCover>
      <StyledTopHeader>
        <StyledGridUnit size={{ mobile: 1 / 3, desktop: 1 / 2 }}>
          <StyledTitle>{t('CostComparision.Country')}</StyledTitle>
        </StyledGridUnit>
        <StyledGridUnit size={{ mobile: 2 / 3, desktop: 1 / 2 }}>
          <StyledTitle>{t('CostComparision.Cost')}</StyledTitle>
        </StyledGridUnit>
      </StyledTopHeader>
      <StyledTableWrapper seeMore={seeMore}>
        <StyledGridWrapper>
          {relationshipData?.country_treatments?.data
            .slice(0, seeMore ? undefined : 3)
            .map(item => (
              <>
                <StyledGridUnit size={{ mobile: 1 / 3, desktop: 1 / 3 }}>
                  <StyledSubText>{item.attributes.country}</StyledSubText>
                </StyledGridUnit>
                <StyledGridUnit size={{ mobile: 1 / 3, desktop: 1 / 3 }}>
                  <StyledCenterAlignWrapper>
                    <StyledSubText>{item.attributes.starting_price}</StyledSubText>
                  </StyledCenterAlignWrapper>
                </StyledGridUnit>
                <StyledGridUnit size={{ mobile: 1 / 3, desktop: 1 / 3 }}>
                  <StyledCenterAlignWrapper>
                    <a
                      href={
                        `/en/packages?treatment_id=${item.attributes.treatment_id}&country=${item.attributes.country}&pageNumber=1`
                        || ''
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <StyledKnowMoreButton>
                        {t('CostComparision.ExploreMore')}
                      </StyledKnowMoreButton>
                    </a>
                  </StyledCenterAlignWrapper>
                </StyledGridUnit>
                <StyledSeprator />
              </>
            ))}
        </StyledGridWrapper>
      </StyledTableWrapper>
      {relationshipData?.country_treatments?.data.length > 3 && (
        <StyledSeeMoreButton onClick={() => setSeeMore(!seeMore)}>
          {seeMore ? t('CostComparision.SeeLess') : t('CostComparision.SeeMore')}
        </StyledSeeMoreButton>
      )}
    </StyledCover>
  );
};

export default withTranslation('ProfilePackages')(CostComparision);
